const getStringValidationMSG = (fieldName: string): string => {
  return `El campo  "${fieldName}" debe ser una cadena de texto válida`;
};

const getNotEmptyValidationMSG = (fieldName: string): string => {
  return `El campo "${fieldName}" no puede estar vacío`;
};

const getNumberValidationMSG = (fieldName: string): string => {
  return `El campo "${fieldName}" debe ser un número válido`;
};

const getRangeNumberValidationMSG = (
  fieldName: string,
  min: number,
  max: number
): string => {
  return `El campo "${fieldName}" debe ser un número entre ${min} y ${max}`;
};

const getBooleanValidationMSG = (fieldName: string): string => {
  return `El campo "${fieldName}" debe ser un valor booleano válido`;
};

const getInvalidEmailValidationMSG = (fieldName: string): string => {
  return `El campo "${fieldName}" debe ser un correo electrónico válido`;
};

type EnumValues = readonly string[];
const getEnumValidationMSG = (
  fieldName: string,
  values: EnumValues
): string => {
  return `El campo "${fieldName}" debe ser uno de los siguientes valores: ${values.join(", ")}`;
};

const getStringArrayValidationMSG = (fieldName: string): string => {
  return `El campo "${fieldName}" debe ser un arreglo de cadenas de texto no vacías`;
};

export {
  getBooleanValidationMSG,
  getNumberValidationMSG,
  getRangeNumberValidationMSG,
  getStringValidationMSG,
  getNotEmptyValidationMSG,
  getInvalidEmailValidationMSG,
  getEnumValidationMSG,
  getStringArrayValidationMSG,
};
